import { useEffect, useRef } from 'react';
export function useTitledValues({ title, onChange, updateParent, resetHeight }) {
    const heightRef = useRef(0);
    function handleUpdateTitle(titles) {
        const finalTitleStr = titles.reduceRight((titleStr, titleFn) => titleFn(titleStr), '');
        if ((document === null || document === void 0 ? void 0 : document.title) !== finalTitleStr) {
            document.title = finalTitleStr;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(finalTitleStr);
    }
    function handleUpdateParent(titles) {
        const nextTitles = titles.concat([title]);
        if (updateParent) {
            updateParent(nextTitles);
        }
        else if (heightRef.current <= nextTitles.length) {
            heightRef.current = nextTitles.length;
            handleUpdateTitle(nextTitles);
        }
    }
    function handleResetHeight() {
        heightRef.current = 0;
        resetHeight === null || resetHeight === void 0 ? void 0 : resetHeight();
    }
    function componentDid() {
        if (updateParent) {
            updateParent([title]);
        }
        else if (heightRef.current <= 1) {
            handleUpdateTitle([title]);
        }
    }
    useEffect(() => {
        componentDid();
        return handleResetHeight;
    });
    return {
        updateParent: handleUpdateParent,
        resetHeight: handleResetHeight
    };
}
